import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowUpRight } from "lucide-react";
import { FadeUp, SectionHeading } from "@/components/Reveal";
import FounderVisual from "@/components/FounderVisual";
import { FOUNDER, CONTACT } from "@/data/services";

export default function FounderSection({ compact = false }) {
  return (
    <section className="mx-auto max-w-[1440px] overflow-hidden px-6 py-24 lg:px-12 lg:py-32" data-testid="founder-section">
      <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
        <FadeUp className="lg:col-span-6">
          <FounderVisual />
        </FadeUp>

        <div className="lg:col-span-6 lg:pl-8">
          <SectionHeading overline={`Founder — ${FOUNDER.hindi}`} lines={["Meet", "Anuj Tiwari."]} testId="founder-heading" />
          <FadeUp delay={0.15}>
            <p className="mt-8 font-hindi text-2xl leading-snug text-saffron sm:text-3xl">{FOUNDER.quote}</p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">{FOUNDER.bio}</p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href={CONTACT.phoneHref}
                data-testid="founder-phone"
                className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 font-mono text-xs uppercase tracking-[0.15em] text-paper transition-colors duration-300 hover:border-saffron hover:text-saffron"
              >
                <Phone className="h-4 w-4" /> {FOUNDER.phone}
              </a>
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="founder-whatsapp"
                className="group inline-flex items-center gap-2 rounded-full border border-[#25D366]/50 px-6 py-3 font-mono text-xs uppercase tracking-[0.15em] text-[#25D366] transition-colors duration-300 hover:bg-[#25D366] hover:text-ink"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp Anuj
              </a>
              {!compact && (
                <Link to="/about" data-testid="founder-about-link" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-brand">
                  Full story <ArrowUpRight className="h-4 w-4" />
                </Link>
              )}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
